import { useExercise } from '@entities/exercise-video/index.ts';
import cn from 'classnames';
import type React from 'react';
import type { ExerciseVideo } from '@shared/types/exercises';
import { Card } from '@shared/ui';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import { useExerciseQuery } from '@src/api/api-hooks/exercises/useExerciseQuery.ts';
import * as st from './styles.module.scss';

interface Props {
  videoId?: number;
  LeftBtn?: JSX.Element;
  RightBtn?: JSX.Element;
  Periodicity?: JSX.Element;
  Schecule?: JSX.Element;
  onExerciseClick: () => void;
  exerciseVideo?: ExerciseVideo;
  className?: string;
}

export const ExerciseCardMobile: React.FC<Props> = ({
  videoId,
  className,
  LeftBtn,
  RightBtn,
  Periodicity,
  Schecule,
  onExerciseClick,
  exerciseVideo: exerciseVideoFromProps,
}) => {
  const { exercise: exerciseFromRTK } = useExercise(videoId);

  const { data: exerciseFromQuery } = useExerciseQuery({
    id:
      typeof exerciseFromRTK !== 'undefined' ||
      typeof exerciseVideoFromProps !== 'undefined' ||
      !videoId
        ? undefined
        : String(videoId),
  });

  const exercise = exerciseVideoFromProps || exerciseFromRTK || exerciseFromQuery;
  // console.log('exercise', exercise);
  return (
    <>
      {exercise && (
        <Card className={cn(st.card, className)} onClick={onExerciseClick}>
          <div className={st.exercise}>
            {LeftBtn && <div className={st.exercise__left}>{LeftBtn}</div>}
            <div className={st.exercise__content}>
              <div className={st.exercise__image}>
                <ImageWithSkeleton
                  src={exercise?.screenshot_url}
                  alt={exercise?.title}
                  className={st.img}
                />
              </div>
              <TextOverflow className={st.exercise__title}>{exercise?.title}</TextOverflow>
            </div>
            <div className={st.exercise__right} onClick={(e) => e.stopPropagation()}>
              {RightBtn && RightBtn}
            </div>
          </div>
          {Schecule && <div className={st.schedule}>{Schecule}</div>}
          <div className={st.exercise__periodicity}>{Periodicity}</div>
        </Card>
      )}
    </>
  );
};
